import { HttpService } from '@/infra'
import type { TTipoProdutoPrecificadoBrasilEnum } from '@/types/produto'
import type {
  TAssinaturaContratoEnum,
  TFormaPagamentoComissaoEnum,
  TOpcaoVagaEnum,
  TTipoEmolumentoEnum,
} from '@/types/proposta'
import type {
  TCondicoesDePrecoProduto,
  TTabelaDePrecoProduto,
  TFormaDePagamentoEnum,
  TPeriodicidadePagamentoEnum,
} from '@/types/simulacao'

export type TRotinaArquivo = {
  rotina: string
  arquivo: string
  valorPresente: number
  comissaoVendedor: number
  valorMedioTotal: number
  valorMedioTotalUPF: number
  margemBruta: number
  margemLiquida: number
  fatorVendedor1Por3: number | null
  fatorVendedor2Por3: number | null
  fatorVendedor3Por3: number | null
  fatorGcom: number
  fatorGR: number
  valorPresentePontoMedio: number
  valorPresentePontoMedioUPF: number
  percentualMargemVenda: number
}

export type TAcessoriosDaUnidade = Array<{
  nome: string
  acessorios: Array<{
    idExterno: number
    nome: string
    metragem: string
  }>
}>

type TPlantaDuplicarProposta = {
  id: string
  nome: string
}

type TVendedorDuplicarProposta = {
  id: string
  nome: string
  possuiDadosDeComissao: boolean
}

type TVagaPadraoDuplicarProposta = {
  idExterno: number
  codigo: string
  substituiVagaPadrao?: boolean
}

type TParticipacaoDuplicarProposta = {
  imobiliariaCorretorIdExterno: string
  tipoImobiliariaCorretor: 'Imobiliaria' | 'CorretorAutonomo'
  nomeImobiliaria: string
  documento: string
  percentualCorretagemImobiliaria: number | null
  valorCorretagemImobiliaria: number | null
  formaPagamentoComissao: TFormaPagamentoComissaoEnum
}

type TPropostaDuplicarCadastroCompradores = {
  nome: string
  documento: string
  ehTitular: boolean
  pessoaId: string
  percentualParticipacao: number
  tipoCliente: 'PessoaFisica' | 'PessoaJuridica'
  vinculos: Array<{
    nome: string
    documento: string
    clienteId: string
    tipo: 'MaePai' | 'Conjuge' | 'Representante' | 'Procurador'
    procuradores: Array<{
      nome: string
      documento: string
      id: string
    }>
  }>
  procuradores: Array<{
    nome: string
    documento: string
    id: string
  }>
  tipoAssinatura: 'Simples' | 'Dupla' | null
}

export type TPropostaDuplicar = {
  nomeEmpreendimento: string
  dataMarcacaoAlvenaria: string | null
  vagasPadrao: TVagaPadraoDuplicarProposta[]
  vendedor: TVendedorDuplicarProposta | null
  planta: TPlantaDuplicarProposta | null
  compradores: TPropostaDuplicarCadastroCompradores[]
  assinaturaContrato: TAssinaturaContratoEnum
  observacoes: string | null
  termosDaProposta: string
  idExternoBloco: number
  opcaoDeVaga: TOpcaoVagaEnum
  tipoEmolumento: TTipoEmolumentoEnum | null
  participacoes: TParticipacaoDuplicarProposta[]
  numero: number
}

export type TPropostaSimulacao = {
  id: string
  dataSimulacao: string
  vendedorId: string
  clienteId: string
  empreendimento: { idExterno: number; nome: string }
  produto: {
    idExterno: number
    tipoDoProduto: TTipoProdutoPrecificadoBrasilEnum
    codigo: string
    nome: string
    metragem: string
    acessorioObrigatorio: boolean
    acessoriosDaUnidade: TAcessoriosDaUnidade
  }
  bloco: {
    idExterno: number
    nome: string
    previsaoDeEntrega: string
  }
  entrada: Array<{ data: string; valor: number }>
  mensais: Array<{ parcelas: Array<{ data: string; valor: number }> }>
  intermediarias: Array<{
    periodicidade: TPeriodicidadePagamentoEnum
    parcelas: Array<{ data: string; valor: number }>
  }>
  saldo: { data: string; valor: number }
  posConclusao: Array<{ data: string; valor: number }>
  intermediariasPosConclusao: Array<{
    periodicidade: TPeriodicidadePagamentoEnum
    parcelas: Array<{ data: string; valor: number }>
  }>
  formaDePagamento: TFormaDePagamentoEnum | null
  rotinaArquivo: TRotinaArquivo
  configuracoesPreco: {
    condicoesDePreco: TCondicoesDePrecoProduto
    tabelaDePreco: TTabelaDePrecoProduto
  }
}

export type TGetPropostaDuplicarResponse = {
  simulacoes: TPropostaSimulacao[]
  proposta: TPropostaDuplicar
}

export class GetPropostaDuplicarService extends HttpService {
  async execute(numero: number) {
    return this.http.get<TGetPropostaDuplicarResponse>(`api/v2/Proposta/${numero}/duplicar`)
  }
}
